import { PreviewFile } from '@eastcoal/common/components/PreviewFile'
import { pick } from '@eastcoal/common/utils/object'

import { useRichEditorStore } from '../../Store/hooks/useStore'

export const PreviewAttachment = () => {
  const { previewFileRef } = useRichEditorStore(state =>
    pick(state, ['previewFileRef'])
  )

  return <PreviewFile ref={previewFileRef} />
}
